import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeScreen from "./Compontents/Home/HomeScreen";
import Homepage from "./Compontents/Home/Homepage";
import Team from "./Compontents/Teams/Team";
import "intersection-observer";
import Contact from "./Compontents/Contact/Contact";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CorporateLandingPage from "./Compontents/CorporateLandingPage/CorporateLandingPage";
import Kiosk from "./Compontents/kiosk/kisokLandingPage";
import Idoc from './Compontents/Idoc/idocRoute'
import WellnessClinical from './Compontents/wellness/routePage'
import DiabetesClinical from './Compontents/diabetes/routePage'
import Clinical_Study from './Compontents/Pages/Clinical_Study';
function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/corporate" element={<CorporateLandingPage />} />{" "}
        <Route path="/kiosk" element={<Kiosk />} />
        <Route path="/aidoc" element={<Idoc />} />
        <Route path="/clinicalStudies/wellness" element={<WellnessClinical />} />
        <Route path='/clinicalStudies/diabetes' element={<DiabetesClinical/>} />
        <Route path="/clinicalStudies" element={<Clinical_Study />} />

      </Routes>
      <Routes>
        <Route path="/" element={<HomeScreen />}>
          <Route index element={<Homepage />} />
          <Route path="team" element={<Team />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

//kiosk

export default App;
